module.exports = __webpack_public_path__ + "b300a9716a82896bfa39c735b001609b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/eyelashes-s.png
// module id = 2323
// module chunks = 0